import { render, staticRenderFns } from "./usehandbook.vue?vue&type=template&id=46d59a6e&scoped=true&"
import script from "./usehandbook.vue?vue&type=script&lang=js&"
export * from "./usehandbook.vue?vue&type=script&lang=js&"
import style0 from "./usehandbook.vue?vue&type=style&index=0&id=46d59a6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d59a6e",
  null
  
)

export default component.exports